import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme/index.scss';
import AppRouter from './AppRouter';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance, msalConfigError } from './config/MsalConfig';
import { DataSelectionProvider } from './context/DataSelectionContext';
import { apiServiceReady, backendHostWarning } from './service/ApiService';

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  // Reject immediately (inside the Promise chain so .catch renders the error UI) if
  // MSAL credentials were not substituted — throwing at module scope would bypass the catch.
  Promise.all([
    msalConfigError ? Promise.reject(new Error(msalConfigError)) : msalInstance.initialize(),
    apiServiceReady,
  ]).then(() => {
    root.render(
      <MsalProvider instance={msalInstance}>
        <DataSelectionProvider>
          {backendHostWarning && (
            <div style={{
              background: '#fff3cd', color: '#664d03',
              padding: '8px 16px', borderBottom: '1px solid #ffc107',
              fontSize: '0.875rem', fontFamily: 'sans-serif',
            }}>
              ⚠ {backendHostWarning}
            </div>
          )}
          <AppRouter />
        </DataSelectionProvider>
      </MsalProvider>
    );
  }).catch((error) => {
    console.error('App initialization failed:', error);
    root.render(
      <div style={{ padding: 32, fontFamily: 'sans-serif' }}>
        <h2>Application failed to start</h2>
        <p>Please refresh the page. If the problem persists, contact support.</p>
        <pre style={{ color: 'red', fontSize: 12 }}>{String(error)}</pre>
      </div>
    );
  });
}
